import axios from 'axios';
import { getToken, clearSession, broadcastLogout } from './authStorage';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
  headers: {
    Accept: 'application/json'
  }
});

apiClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearSession();
      broadcastLogout();
    }
    return Promise.reject(error);
  }
);

export const getErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  const data = error.response?.data;
  if (data?.errors?.length) {
    return data.errors.map((e) => e.msg).join(', ');
  }
  return data?.message || error.message || fallback;
};

export default apiClient;
